function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.showFormButton = this.querySelector('.show_search_btn');
    this.form = this.input?.form;
    this.isMobile = window.matchMedia('(max-width: 1319px)');

    if (this.input) {
      this.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    if (this.showFormButton) {
      this.showFormButton.addEventListener('click', this.showForm.bind(this));
    }

    // Listen for media query changes
    this.isMobile.addEventListener('change', this.updateMobileState.bind(this));

    // Initialize based on current screen size
    this.updateMobileState(this.isMobile);
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  showForm(event) {
    event.preventDefault();

    if (this.isMobile.matches) {
      if (this.input.value.length > 0) {
        // If input has text, submit the form
        this.form.submit();
      } else {
        // Toggle the visibility of the search form
        this.classList.toggle('active');
        this.input.focus();
      }
    }
  }

  updateMobileState(mediaQuery) {
    if (!mediaQuery.matches) {
      // Desktop behavior: Ensure form is always visible
      this.classList.add('active');
      this.showFormButton.style.display = 'none';
    } else {
      this.classList.remove('active');
      this.showFormButton.style.display = 'block';
    }
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the URL on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
